import React from "react";
import { FaTag, FaXmark } from "react-icons/fa6";

const PromoCodeInput = ({ value, onChange, onClear, onApply, loading }) => {
  const isFilled = value && value.trim() !== "";

  return (
    <div className="mb-3">
      <label className="block text-xs font-medium text-gray-700 !mb-2">
        Have a promo code?
      </label>

      <div className="flex items-center gap-2">
        {/* Input */}
        <div className="relative flex-1 w-full">
          <FaTag className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />

          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value.toUpperCase())}
            placeholder="ENTER CODE"
            className="w-full pl-10 pr-10 py-2 ring-1 !ring-[#e6e6e6] rounded-lg 
                       focus:ring-2 focus:ring-blue-500 uppercase bg-white shadow-sm !m-0"
          />

          {isFilled && (
            <button
              type="button"
              onClick={onClear}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 !bg-transparent !p-0"
            >
              <FaXmark className="w-4 h-4" />
            </button>
          )}
        </div>

        {/* Apply Button */}
        <button
          type="button"
          onClick={onApply}
          disabled={!isFilled || loading}
          className={`
            px-4 py-2.5 !w-fit rounded-lg font-medium text-sm text-white
            ${
              loading || !isFilled
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-[#302571] hover:bg-[#302571]/90"
            }
          `}
        >
          {loading ? "Applying…" : "Apply"}
        </button>
      </div>
    </div>
  );
};

export default PromoCodeInput;
